import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css, keyframes } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const keyframesLoadingSpinnerAlt = keyframes`
  0% {
    stroke-dashoffset: 502;
  }
  100% {
    stroke-dashoffset: 0;
  }
`
const keyframesLoadingSpinnerAltDashArray = keyframes`
  0% {
    stroke-dasharray: 1 250;
  }
  50% {
    stroke-dasharray: 125.5 125.5;
  }
  100% {
    stroke-dasharray: 1 250;
  }
`
const cssLoadingText = css`
  position: absolute;
  left: 0px;
  right: 0px;
  top: initial !important;
  bottom: 50% !important;
  text-align: center;
  color: ${theme.color.neutral70};
`
const cssLoadingSpinnerAlt = css`
  width: 100px;
  height: 100px;
`
const cssLoadingSpinnerRing = css`
  stroke: ${theme.color.neutral30};
  fill: none;
  stroke-width: 10;
  stroke-linecap: round;
`
const cssLoadingSpinnerCircle = css`
  stroke: ${theme.color.teal50};
  fill: none;
  stroke-width: 6;
  stroke-linecap: round;
  animation-name: ${keyframesLoadingSpinnerAlt},
    ${keyframesLoadingSpinnerAltDashArray};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`

interface GridLoadingProps {
  hide?: boolean
  className?: string
}

// copied from angular component "views/common/grid-loading.html"
export const GridLoading = ({ hide, className }: GridLoadingProps) => {
  if (hide) {
    return null
  }

  return (
    <div data-testid="grid-loading">
      <div className={className ?? cssLoadingText}>
        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          className={cssLoadingSpinnerAlt}
        >
          <circle cx="50" cy="50" r="40" className={cssLoadingSpinnerRing} />
          <circle cx="50" cy="50" r="40" className={cssLoadingSpinnerCircle} />
        </svg>
        <div>
          <FormattedMessage id="title_working" />
        </div>
      </div>
    </div>
  )
}
